import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrEmptyString } from '../../../../shared/utils';
import { CLPUser, UserResponse } from '../../../models/clpuser.model';
import { ContactListResponse } from '../../../models/contact.model';
import { eDDField, eFeatures, eNoteOwnerType, eUserRole } from '../../../models/enum.model';
import { DropDownItem, IntDropDownItem, IntDropDownItemListResponse, SimpleResponse, UserDD } from '../../../models/genericResponse.model';
import { CustomSearchResponse } from '../../../models/report.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { AddToSearchReq, ContactSearchReq, ContactSearchRequest, Item, PowerSearchFilterResponse, PowerSearchRequest, PowerSearchRes, PowerSearchSaveRequest, SearchClause, SearchItem, SearchItemListResponse, UserDDSearchReq } from '../../../models/search.model';
import { AccountSetupService } from '../../../services/accountSetup.service';
import { ClassCodeService } from '../../../services/classCode.service';
import { EngageMetricService } from '../../../services/engage-metric.service';
import { GlobalService } from '../../../services/global.service';
import { NotificationService } from '../../../services/notification.service';
import { ReportService } from '../../../services/report.service';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { ContactCommonSearchService } from '../../../services/shared/contact-common-search.service';
import { LocalService } from '../../../services/shared/local.service';
import { isNullOrUndefined, UtilityService } from '../../../services/shared/utility.service';

@Component({
    selector: 'app-contact-power-search',
    templateUrl: './contact-power-search.component.html',
    styleUrl: './contact-power-search.component.css'
})
export class ContactPowerSearchComponent implements OnInit {
    searchQueriesForm: FormGroup
    encryptedUser: string = '';
    userResponse: UserResponse;
    user: CLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;


    powerSearchItemList: PowerSearchFilterResponse;
    ddField: DropDownItem[];
    usersObj: UserDD[];
    officeObj: IntDropDownItem[];
    teamObj: IntDropDownItem[];
    tagsObj: IntDropDownItem[];
    secClause: string;
    metricList: string[];

    isAdvancedSearch: boolean = false;
    isQuickSearch: boolean = false;
    isPowerSearch: boolean = true;

    contactListResponse: ContactListResponse;
    contactSearchReq: ContactSearchReq;
    contactSearchReqObj: ContactSearchRequest;
    userDDSearchReqObj: UserDDSearchReq;
    addToSearchReq: AddToSearchReq;

    isShowMetricValues: boolean = false;
    isMetricTextSearch: boolean = false;
    listMetricValue: string[];

    isTrOutlookSync: boolean = false;
    @Input() searchId: number = 0
    isShowPnlSaved: boolean = false;
    displayName: string = "";
    isShowDisplayText: boolean = false;
    ddcustomsearch: CustomSearchResponse[] = [];
    customsearch: CustomSearchResponse = <CustomSearchResponse>{};
    displayClause: string = "";
    searchContactCount: string = "";

    isAndOr: boolean = false;
    lblField: string = "";
    islblField: boolean = false;
    islblOperator: boolean = false;
    isddOpClass: boolean = false;
    isddValue: boolean = false;
    islblCBValue: boolean = false;
    ddValueList: IntDropDownItem[] = [];
    isEditCB: boolean = false;
    isUseExtendedSearch: boolean = false;
    isEditText: boolean = false;
    islblTextValue: boolean = false;
    islblDDValue: boolean = false;
    trOperator: boolean = false;
    trMetricDetails: boolean = false;
    trTags: boolean = false;
    trBuzzScore: boolean = false;
    trEngagement: boolean = false;
    trField: boolean = true;
    //selectedFromDate = new Date();
    //selectedToDate = new Date();
    trEditDate: boolean = false;
    lblOperator: string = '';
    isStartOver: boolean = false;
    isAddToSearch: boolean = false;
    isEmailRequired: boolean = false;
    emailType: number = 0;
    sbClauseUser: string = '';
    clauseUser: string = '';
    powerSearchRequest: PowerSearchRequest = <PowerSearchRequest>{};
    searchClauseList: SearchClause[] = [];
    havingScore: string = '';
    havingScoreDisplay: string = '';
    whereClause: string = '';
    lblMetricName: string = '';
    islblMessage: boolean = true;
    powerSearchSaveReq: PowerSearchSaveRequest = <PowerSearchSaveRequest>{};
    userClauseText: string = '';
    isUserDD: boolean = false;
    isTeamDD: boolean = false;
    isOfficeDD: boolean = false;
    searchStatement: boolean = false;
    isEditMode: boolean = false;
    isddOpSearchText: boolean = false;
    showSpinner: boolean = false;
    constructor(private fb: FormBuilder,
        private _globalService: GlobalService,
        private _router: Router,
        private _utilityService: UtilityService,
        private _localService: LocalService,
        private engageMetricService: EngageMetricService,
        private _searchContactService: SearchContactService,
        private _reportService: ReportService,
        public _contactSearchService: ContactCommonSearchService,
        private notifyService: NotificationService,
        private _accountSetupService: AccountSetupService,
        public _classCodeService: ClassCodeService,
        public _datePipe: DatePipe,

    ) {

    }



    async ngOnInit() {
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(async () => {
                    if (this.user) {
                        this.searchQueriesForm = this.prepareSearchQueriesForm();
                        await this.getContactPowerSearchFilters();
                        this.getddCustomSearchList();
                        this.searchSetup();
                        await this.calculateRecordCount();
                    }
                    else {
                        this._router.navigate(['/unauthorized']);
                    }
                });
            }
            else {
                this._router.navigate(['/unauthorized']);
            }
        });
    }

    onShowQuickSearch() {
        this._contactSearchService.QuickSearchToggle(true);
    }

    onShowAdvanceSearch() {
        this._contactSearchService.advanceSearchToggle(true);
    }
    searchSetup() {
        this.isAndOr = false;
        this.isAddToSearch = false;
        this.isStartOver = false;

        this.setUpSearchField()
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.None)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (this.userResponse) {
                        if (this.userResponse?.user) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-new-search.authenticateR", err.message, null,
                    'Feature: ' + eFeatures.None
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    prepareSearchQueriesForm() {
        const dtToday = new Date();
        const firstDayOfMonth = new Date(dtToday.getFullYear(), dtToday.getMonth(), 1);
        const firstDayOfNextMonth = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth() + 1, 1);
        const lastDayOfCurrentMonth = new Date(firstDayOfNextMonth.getTime() - 1 * 24 * 60 * 60 * 1000);

        return this.fb.group({
            ddAndOr: ['AND'],
            ddField: [''],
            txtSearch: [''],
            ddValue: [''],
            fromDate: [firstDayOfMonth],
            toDate: [lastDayOfCurrentMonth],
            ddOutlookSync: ['-1'],

            ddOpCoTags: ['any'],
            ddOpTags: ['any'],
            ddMetricNames: [''],
            ddMetricValues: ['any'],
            txtMetricTextSearch: [''],
            lbMetricsSelected: [''],
            txtBuzzStart: [''],
            txtBuzzEnd: [''],
            ddOpSearchText: ['='],
            ddOpTeam: ['='],
            ddOpOffice: ['='],
            ddOpUser: ['='],

            ddTeam: [[]],
            ddOffice: [[]],
            ddUser: [[this.user?.cLPUserID.toString()]],
            lbTags: [[]],
            cbLimit: [false],
            ddOpClass: ['='],
            cbValue: [false],
            ddEngagementType: [''],
            ddEngagementOperator: [''],
            ddEngagementValue: [''],
            ddcustomsearch: ['']
        })
    }

    async getContactPowerSearchFilters() {
        this.showSpinner = true;
        await this._searchContactService.getPowerSearchFields(this.encryptedUser, this.user.cLPCompanyID)
            .then(async (result: PowerSearchFilterResponse) => {
                if (result) {
                    this.powerSearchItemList = UtilityService.clone(result);
                    this.ddField = this.powerSearchItemList?.fieldDD;
                    this.usersObj = this.powerSearchItemList?.userList;

                    this.officeObj = this.powerSearchItemList?.officeCodes;
                    this.teamObj = this.powerSearchItemList?.teamCodes;
                    this.metricList = this.powerSearchItemList.metricList;
                    this.secClause = this.powerSearchItemList.secClause;
                    this.tagsObj = this.powerSearchItemList.tagList;
                    this.isUserDD = this.usersObj?.length > 0;
                    this.isTeamDD = this.teamObj?.length > 0;
                    this.isOfficeDD = this.officeObj?.length > 0;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-new-search.getContactPowerSearchFilters", err.message, null,
                    'cLPCompanyID: ' + this.user.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async getddCustomSearchList() {
        this.showSpinner = true;
        await this._searchContactService.customSearchs_GetList(this.encryptedUser, this.user?.cLPUserID, this.user?.cLPCompanyID, 2, true)
            .then(async (result: CustomSearchResponse[]) => {
                if (result) {
                    if (result.length > 0) {
                        this.ddcustomsearch = UtilityService.clone(result);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    onFieldChange(event) {
        this.trOperator = true;
        if (event?.target?.value != '0') {
            const field = this.ddField.find(item => item.value == event?.target?.value);
            this.lblField = field?.text;
            this.islblField = true;
            this.setupValueRow(event?.target?.value);
            this.isAddToSearch = true;
            this.islblMessage = false;
            this.isUserDD = this.usersObj?.length > 0;
            this.isTeamDD = this.teamObj?.length > 0;
            this.isOfficeDD = this.officeObj?.length > 0;
        }
    }
    setupValueRow(val) {
        this.islblOperator = false;
        this.isddOpSearchText = false;
        this.isddOpClass = true;
        this.isddValue = true;
        this.islblCBValue == false;
        switch (val) {
            case 'Contact.Shareable':
            case 'Contact.Check1':
            case 'Contact.Check2':
            case 'Contact.Check3':
            case 'Contact.Check4':
            case 'Contact.Check5':
            case 'Contact.Check6':
            case 'Contact.OutlookSync':
            case 'Contact.Check1':
            case 'Contact.Check2':
            case 'Contact.Check3':
            case 'Contact.Check4':
                this.manageFlags('isEditCB');
                this.islblOperator = false;
                this.isddOpClass = false;
                //this.isddValue = false;
                this.islblCBValue == false;
                //this.isEditCB = true;
                //this.trEditDate = false;
                //this.isEditText = false;

                //this.trBuzzScore = false;
                //this.trMetricDetails = false
                //this.trTags = false;
                //this.trEngagement = false;
                break;
            case 'ContactMore.CustomDate1':
            case 'ContactMore.CustomDate2':
            case 'ContactMore.CustomDate3':
            case 'ContactMore.CustomDate4':
            case 'ContactMore.CustomDate5':
            case 'Contact.dtModified':
            case 'Contact.dtCreated':
                this.manageFlags('trEditDate');

                this.isddValue = false;
                this.trOperator = true;
                this.islblOperator = true;
                this.lblOperator = ' is '
                this.isddOpClass = false;
                this.islblCBValue == false;
                this.isUseExtendedSearch = true;
                this.searchQueriesForm.get('txtSearch')?.setValue('');
                break;

            //#region Contact ClassCodes
            case 'Contact.Class1Code':
                this.manageFlags('isddValue');
                this.islblDDValue = false;
                this.ddValueList = [];
                this.getClassCode(eDDField.Class1Code);
                break;
            case 'Contact.Class2Code':
                this.manageFlags('isddValue');

                this.islblDDValue = false;
                this.ddValueList = [];
                this.getClassCode(eDDField.Class2Code);
                break;
            case 'Contact.Class3Code':
                this.manageFlags('isddValue');

                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class3Code);
                break;
            case 'Contact.Class4Code':
                this.manageFlags('isddValue');

                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class4Code);
                break;
            case 'Contact.Class5Code':
                this.manageFlags('isddValue');

                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class5Code);
                break;
            case 'Contact.Class6Code':
                this.manageFlags('isddValue');

                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class6Code);
                break;
            case 'Contact.Class7Code':
                this.manageFlags('isddValue');

                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class7Code);
                break;
            case 'Contact.Class8Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.Class8Code);
                break;
            //#endregion Contact ClassCodes

            //#region Company ClassCodes
            case 'Company.CoClass1Code':
                this.manageFlags('isddValue');
                this.islblDDValue = false;
                this.ddValueList = [];
                this.getClassCode(eDDField.CoClass1Code);
                break;
            case 'Company.CoClass2Code':
                this.manageFlags('isddValue');
                this.islblDDValue = false;
                this.ddValueList = [];
                this.getClassCode(eDDField.CoClass2Code);
                break;
            case 'Company.CoClass3Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass3Code);
                break;
            case 'Company.CoClass4Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass4Code);
                break;
            case 'Company.CoClass5Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass5Code);
                break;
            case 'Company.CoClass6Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass6Code);
                break;
            case 'Company.CoClass7Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass7Code);
                break;
            case 'Company.CoCoClass8Code':
                this.manageFlags('isddValue');
                this.ddValueList = [];
                this.islblDDValue = false;
                this.getClassCode(eDDField.CoClass8Code);
                break;
            //#endregion Company ClassCodes

            //case 'ContactMore.CustomText1':
            case 'ContactMore.CustomText1':
            case 'ContactMore.CustomText2':
            case 'ContactMore.CustomText3':
            case 'ContactMore.CustomText4':
            case 'ContactMore.CustomText5':
            case 'ContactMore.CustomDate1Title':
            case 'ContactMore.CustomDate2Title':
            case 'ContactMore.CustomDate3Title':
            case 'ContactMore.CustomDate4Title':
            case 'ContactMore.CustomDate5Title':
                this.manageFlags('isEditText');
                this.islblOperator = false;
                this.isddOpClass = false;
                this.islblTextValue = false;
                this.isddOpSearchText = true;
                this.isUseExtendedSearch = true;
                break;

            case 'SOMetric.MetricName':
                this.manageFlags('trMetricDetails');
                this.trOperator = false;
                break;
            case 'Tag':
                this.manageFlags('trTags');
                this.trOperator = false;
                break;
            case 'BuzzScore':
                this.manageFlags('trBuzzScore');

                this.trOperator = false;
                this.isAndOr = false
                break;

            case 'Contact.isOptOutTxtMsg':
                this.manageFlags('isddValue');
                this.islblDDValue = false;
                this.ddValueList = [];
                this.ddValueList = [
                    { id: 3, text: 'Soft Opted Out' },
                    { id: 0, text: 'Hard Opt Out' },
                    { id: 1, text: 'Opted In' },
                ];
                break;
            case 'Contact.isOptOutEmail':
            case 'ISNULL(se.InfoSubStatus, 1)':
            case 'ISNULL(se.PromoSubStatus, 1)':
                this.manageFlags('isddValue');
                this.islblDDValue = false;
                this.ddValueList = [];
                this.ddValueList = [
                    { id: 0, text: 'Subscribed' },
                    { id: 1, text: 'Unsubscribed' },
                ];
                break;
            case 'Engagement':
                this.trOperator = false;
                this.isAndOr = false;
                this.trEngagement = true;
                this.ddValueList = [];
                this.ddValueList = [
                    { id: 0, text: 'Subscribed' },
                    { id: 1, text: 'Unsubscribed' },
                ];
                break;

            default:
                this.trOperator = true
                this.isEditText = true;
                this.islblOperator = false;
                this.isddOpClass = false;
                this.islblTextValue = false;
                this.isddValue = false;
                this.isddOpSearchText = true;
                break;
        }
    }

    manageFlags(val: string) {
        this.isEditText = false;
        this.isddValue = false;
        this.isEditCB = false;
        this.trEditDate = false;
        this.trMetricDetails = false
        this.trTags = false;
        this.trBuzzScore = false;
        this.trEngagement = false;
        this.isddOpSearchText = false;

        switch (val) {
            case 'isEditText': this.isEditText = true;
                break;
            case 'isddValue': this.isddValue = true;
                break;
            case 'isEditCB': this.isEditCB = true;
                break;
            case 'trEditDate': this.trEditDate = true;
                break;
            case 'trMetricDetails': this.trMetricDetails = true;
                break;
            case 'trTags': this.trTags = true;
                break;
            case 'trBuzzScore': this.trBuzzScore = true;
                break;
            case 'trEngagement': this.trEngagement = true;
                break;

            default:
        }
    }

    convertToDropDownItems(itemData: Item[]): IntDropDownItem[] {
        return itemData.map((item) => ({
            id: item.value,
            text: item.display,
        }));
    }


    setUpSearchField() {
        //this.isAndOr =   clauseGrid.lenth > 0 ?true : false ;
        this.trField = true;
        this.islblField = false;
        this.trOperator = false;
        this.isEditText = false;
        this.isddValue = false;
        this.isEditCB = false;
        this.trEditDate = false;
        this.trMetricDetails = false;
        this.trEngagement = false;
        this.trTags = false;
        this.trBuzzScore = false;
        this.islblDDValue = false;
        this.isAddToSearch = false;
        this.isddOpClass = false;
        this.islblOperator = false;
        this.isUserDD = this.usersObj?.length > 0;
        this.isTeamDD = this.teamObj?.length > 0;
        this.isOfficeDD = this.officeObj?.length > 0;
        this.isddOpSearchText = true;
    }

    async onSearchChange(event: any) {
        const id = +event.target.value;
        if (id > 0) {
            this.isUserDD = false;
            this.isTeamDD = false;
            this.isOfficeDD = false;
            this.searchId = id;
            this.showSpinner = true;
            await this._searchContactService.PowerSearch_Load(this.encryptedUser, id)
                .then(async (result: PowerSearchRes) => {
                    if (result && result.messageBool) {
                        let response = UtilityService.clone(result);
                        this.customsearch = response.customSearchResponse;
                        this.searchClauseList = response.searchClause ? response.searchClause : [];
                        this.islblMessage = false;
                        this.displayName = this.customsearch.displayName;
                        this.whereClause = this.customsearch.whereClause;
                        if (this.searchClauseList?.length > 0) {
                            this.secClause = response.secClause;
                            this.userClauseText = response.userClauseText;
                            this.sbClauseUser = response.userClauseText;
                            this.clauseUser = response.clauseUser;
                            this.isUserDD = true;
                            this.searchStatement = false;
                            this.isEditMode = true;
                            this.trField = true;
                        }
                        else {
                            this.trField = false;
                            this.sbClauseUser = '';
                            this.searchStatement = true;
                            this.isEditMode = false;
                        }
                        this.searchContactCount = response.messageInt + " records found";
                        this.isStartOver = true;
                        this.isShowPnlSaved = false;
                        this.isShowDisplayText = false;
                        this.isUseExtendedSearch = true;
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                });
        }
        else {
            this.customsearch = <CustomSearchResponse>{};
            this.searchContactCount = "";
        }
    }
    async getContactSearchCount(customSearchID: number = 0) {
        this.showSpinner = true;
        await this._searchContactService.getContact_NewSearchCount(this.encryptedUser, customSearchID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var simpleResponse = UtilityService.clone(result);
                    this.searchContactCount = simpleResponse.messageInt + " records found";
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async getSeachResult() {
        this.showSpinner = true;
        await this._searchContactService.getContact_NewSearchResult(this.encryptedUser, this.customsearch.customSearchID, this.user?.cLPUserID, true)
            .then(async (result: ContactListResponse) => {
                if (result) {
                    this.contactListResponse = UtilityService.clone(result);
                    if (this.contactListResponse?.messageString?.includes('Invalid search.'))
                        this.notifyService.showError(result.messageString, '', 3000);
                    else {
                        this._contactSearchService.contactListChanged.emit(this.contactListResponse.contactList);
                        this._contactSearchService.contactCountChanged.emit(this.contactListResponse.messageInt);
                    }
                    this.isStartOver = true;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async deleteSearch() {
        this.showSpinner = true;
        await this._searchContactService.contact_deleteCustomSearch(this.encryptedUser, this.customsearch.customSearchID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.messageBool) {
                        this.getddCustomSearchList();
                        this.onStartOver();
                        this.notifyService.showSuccess('Saved search has been deleted.', "", 3000);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    onStartOver() {
        this.customsearch = <CustomSearchResponse>{};
        this.searchSetup();
        this.searchClauseList = [];
        this.searchQueriesForm.get('txtSearch')?.setValue('');
        this.searchQueriesForm.get('ddAndOr')?.setValue('AND');
        this.searchQueriesForm.get('ddField')?.setValue('');
        this.searchQueriesForm.get('ddcustomsearch')?.setValue('');
        this.sbClauseUser = '';
        this.havingScore = '';
        this.havingScoreDisplay = '';
        this.whereClause = '';
        this.lblMetricName = '';
        this.calculateRecordCount();
        this.islblMessage = true
        this.searchId = 0;
        this.searchStatement = false;
        this.isShowPnlSaved = false;
        this.displayName = '';
    }

    onRefresh() {
        this.customsearch = <CustomSearchResponse>{};
        this.calculateRecordCount();
        this.setUpSearchField();
        this.searchQueriesForm.get('txtSearch')?.setValue('');
        this.searchQueriesForm.get('ddField')?.setValue('');
        this.searchQueriesForm.get('ddAndOr')?.setValue('AND');
        if (this.searchClauseList.length > 0) this.isStartOver = true;
    }

    async saveCustomSearch() {
        if (this.isShowDisplayText == false) {
            this.isShowDisplayText = true;
            return;
        }
        if (!isNullOrUndefined(this.displayName) && this.displayName != "") {
            this.setPowerSearchSaveRequest();
            this.showSpinner = true;
            await this._searchContactService.SavePowerSearch(this.encryptedUser, this.user?.cLPUserID, this.user.cLPCompanyID, this.powerSearchSaveReq)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        var response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.isShowDisplayText = false;
                            this.customsearch.customSearchID = response.messageInt;
                            this.displayName = "";
                            this.isShowPnlSaved = false;
                            this.getddCustomSearchList();
                            this.searchId = response.messageInt;
                            this.notifyService.showSuccess('Search has been saved.', "", 3000);
                        }
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                });
        }
    }

    setPowerSearchSaveRequest() {
        this.customsearch.havingScore = this.havingScore;
        this.customsearch.displayName = this.displayName;
        this.customsearch.clpCompanyID = this.user?.cLPCompanyID;
        this.customsearch.clpUserID = this.user?.cLPUserID;
        this.customsearch.objectType = eNoteOwnerType.Contact;
        this.customsearch.whereClause = this.whereClause;
        this.customsearch.isSavedSearch = true;

        this.powerSearchSaveReq = <PowerSearchSaveRequest>{}
        this.powerSearchSaveReq.searchClause = this.searchClauseList;
        this.powerSearchSaveReq.customSearchResponse = this.customsearch;
        this.powerSearchSaveReq.clauseUser = this.clauseUser;
        this.powerSearchSaveReq.userClauseText = this.userClauseText;
        this.powerSearchSaveReq.secClause = this.secClause;
        this.powerSearchSaveReq.isEditMode = this.isEditMode;
    }


    async runPowerSearch() {
        //if (this.customsearch !== null && this.customsearch !== undefined && Object.keys(this.customsearch).length > 0 && this.customsearch.customSearchID) {
        //    await this.getSeachResult();
        //    this.isShowPnlSaved = false;
        //}
        //else
        if (this.whereClause != '') {
            this.setContactSearchReqObj();
            this.showSpinner = true;
            this._searchContactService.GetContact_SearchResult(this.encryptedUser, this.user?.cLPUserID, this.user.cLPCompanyID, this.contactSearchReqObj)
                .then(async (result: ContactListResponse) => {
                    if (result) {
                        this.contactListResponse = UtilityService.clone(result);
                        this._globalService.searchWhereClause = this.whereClause;
                        this._globalService.havingScore = this.havingScore != '' ? this.havingScore : '';
                        if (this.contactListResponse?.messageString?.includes('Invalid search.'))
                            this.notifyService.showError(result.messageString, '', 3000);
                        else {
                            this._contactSearchService.contactListChanged.emit(this.contactListResponse.contactList);
                            this._contactSearchService.contactCountChanged.emit(this.contactListResponse.messageInt);
                        }
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("contact-common-search.getContactSearch", err.message, null,
                        'cLPCompanyID: ' + this.user.cLPCompanyID
                    );
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                });
        }
    }

    setContactSearchReqObj() {
        this.contactSearchReqObj = <ContactSearchRequest>{};
        this.contactSearchReqObj.havingScore = this.havingScore;
        this.contactSearchReqObj.orderBy = '';
        this.contactSearchReqObj.whereClause = this.whereClause;
        this.contactSearchReqObj.isExtended = this.isUseExtendedSearch;
        this.contactSearchReqObj.isIncludeMetrics = false
        //this.contactSearchReqObj.intRowCount = false

    }
    onddAndOrChange() {
        this.trField = true;
    }
    onAddToSearch() {
        this.setAddToSearchReq();
        this.setUpSearchField();
        this.searchQueriesForm.get('txtSearch')?.setValue('');
        this.searchQueriesForm.get('ddField')?.setValue('');
        this.searchQueriesForm.get('ddAndOr')?.setValue('AND');
        this.setupSearchSummary();
        if (this.searchClauseList.length > 0) {
            this.isStartOver = true;
            this.isShowPnlSaved = true;
        }
    }

    setAddToSearchReq() {
        this.addToSearchReq = <AddToSearchReq>{}
        this.addToSearchReq.ddAndOr = this.searchQueriesForm.controls['ddAndOr'].value
        this.addToSearchReq.ddField = this.searchQueriesForm.controls['ddField'].value
        this.addToSearchReq.ddOpSearchText = this.searchQueriesForm.controls['ddOpSearchText'].value
        this.addToSearchReq.txtSearch = this.searchQueriesForm.controls['txtSearch'].value
        this.addToSearchReq.ddValue = this.searchQueriesForm.controls['ddValue'].value
        this.addToSearchReq.cbValue = this.searchQueriesForm.controls['cbValue'].value
        this.addToSearchReq.fromDate = this.searchQueriesForm.controls['fromDate'].value
        this.addToSearchReq.toDate = this.searchQueriesForm.controls['toDate'].value
        this.addToSearchReq.ddOpClass = this.searchQueriesForm.controls['ddOpClass'].value

        this.addToSearchReq.ddMetricNames = this.searchQueriesForm.controls['ddMetricNames'].value
        this.addToSearchReq.ddMetricValues = this.searchQueriesForm.controls['ddMetricValues'].value
        this.addToSearchReq.lbMetricsSelected = this.searchQueriesForm.controls['lbMetricsSelected'].value
        this.addToSearchReq.txtMetricTextSearch = this.searchQueriesForm.controls['txtMetricTextSearch'].value

        this.addToSearchReq.ddOpTags = this.searchQueriesForm.controls['ddOpTags'].value
        this.addToSearchReq.lbTags = this.searchQueriesForm.controls['lbTags'].value

        this.addToSearchReq.buzzEnd = this.searchQueriesForm.controls['txtBuzzEnd'].value
        this.addToSearchReq.buzzStart = this.searchQueriesForm.controls['txtBuzzStart'].value

        this.addToSearchReq.ddEngagementType = this.searchQueriesForm.controls['ddEngagementType'].value
        this.addToSearchReq.ddEngagementOperator = this.searchQueriesForm.controls['ddEngagementOperator'].value
        this.addToSearchReq.ddEngagementValue = this.searchQueriesForm.controls['ddEngagementValue'].value
        this.addToSearchReq.emailType = this.emailType;
        this.addToSearchReq.isEmailRequired = false
        this.addToSearchReq.isShowScore = false
        this.addToSearchReq.secClause = this.secClause;
        this.addToSearchReq.searchId = this.searchId;
        this.addToSearchReq.useExtendedSearch = this.isUseExtendedSearch;

        this.addToSearchReq.isEditText = this.isEditText;
        this.addToSearchReq.isddValue = this.isddValue
        this.addToSearchReq.isEditCB = this.isEditCB;
        this.addToSearchReq.isEditDate = this.trEditDate;
        this.addToSearchReq.isBuzzScore = this.trBuzzScore;
        this.addToSearchReq.isMetricDetails = this.trMetricDetails;
        this.addToSearchReq.isTags = this.trTags;
        this.addToSearchReq.isEngagement = this.trEngagement;

    }

    setUserDDSearchReq() {
        this.userDDSearchReqObj = <UserDDSearchReq>{}
        //this.UserDDSearchReqObj.ddOpClass = this.searchQueriesForm.controls['ddOpClass'].value
        this.userDDSearchReqObj.ddOpUser = this.searchQueriesForm.controls['ddOpUser'].value
        this.userDDSearchReqObj.clpuserId = this.searchQueriesForm.controls['ddUser'].value;
        this.userDDSearchReqObj.ddOpTeam = this.searchQueriesForm.controls['ddOpTeam'].value
        this.userDDSearchReqObj.ddOpOffice = this.searchQueriesForm.controls['ddOpOffice'].value
        this.userDDSearchReqObj.ddTeam = this.searchQueriesForm.controls['ddTeam'].value
        this.userDDSearchReqObj.ddOffice = this.searchQueriesForm.controls['ddOffice'].value

    }

    onRemoveSearch(index: number) {
        if (index > -1 && index < this.searchClauseList.length) {
            this.searchClauseList.splice(index, 1);
        }
        if (this.searchClauseList.length > 0 && (this.searchClauseList[0].clauseText.trim().startsWith('OR') || this.searchClauseList[0].clauseText.trim().startsWith('AND'))) {
            //console.log(this.searchClauseList[0].clauseText.trim().replace(/^(OR |AND )/i, ''));
            const indexOfOR: number = this.searchClauseList[0].clauseText.indexOf('OR')
            const indexOfAND: number = this.searchClauseList[0].clauseText.indexOf('AND')
            if (indexOfOR > -1 && indexOfOR < 2) {
                this.searchClauseList[0].clauseText = this.searchClauseList[0].clauseText.substring(indexOfOR + 2);
                this.searchClauseList[0].sQLClause = this.searchClauseList[0].sQLClause.substring(indexOfOR + 2);
            }
            if (indexOfAND > -1 && indexOfAND < 2) {
                this.searchClauseList[0].clauseText = this.searchClauseList[0].clauseText.substring(indexOfAND + 3);
                this.searchClauseList[0].sQLClause = this.searchClauseList[0].sQLClause.substring(indexOfAND + 3);
            }
        }
        this.calculateRecordCount();
        if (this.searchClauseList.length > 0) {
            this.isStartOver = true;
            this.isShowPnlSaved = true;
        } else {
            this.isStartOver = false;
            this.isShowPnlSaved = false;
        }
    }

    async getClassCode(classCodeNum) {
        this.showSpinner = true;
        await this._classCodeService.GetClassCodesDD(this.encryptedUser, classCodeNum, this.user?.cLPCompanyID)
            .then(async (result: IntDropDownItemListResponse) => {
                if (!isNullOrUndefined(result))
                    this.ddValueList = UtilityService.clone(result?.intDropDownItemList);
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact.getClassCode", err.message, null,
                    'cLPCompanyID: ' + this.user?.cLPCompanyID
                );
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async setUserDDDisplay() {

        this.sbClauseUser = '';
        let strClauseUser: string = '';

        if (this.isEmailRequired)
            this.sbClauseUser += this.emailType ? " &nbsp;AND Email Promo Status is 'Subscribed'" : " &nbsp;AND Email Info Status is 'Subscribed'";

        const clpUserList = this.userDDSearchReqObj?.clpuserId;
        if (clpUserList && clpUserList.length > 0 && !(clpUserList.length == 1 && clpUserList[0] == "0")) {
            clpUserList.forEach(user => {
                const filterdUser = this.usersObj.find(x => x.value.toString() == user);
                if (!isNullOrUndefined(filterdUser))
                    strClauseUser += this.usersObj.find(x => x.value.toString() == user).text + "<br />&nbsp;&nbsp;&nbsp;OR ";
            });
            strClauseUser = "<br />&nbsp;&nbsp;&nbsp;(" + strClauseUser.substring(0, strClauseUser.length - 27) + ")";
            strClauseUser = "<br /> AND User includes " + strClauseUser;
            this.sbClauseUser += strClauseUser;

        }
        this.userClauseText = strClauseUser

        let strClauseTeam: string = "";
        const ddTeamList = this.userDDSearchReqObj?.ddTeam;
        if (ddTeamList && ddTeamList.length > 0 && !(ddTeamList.length == 1 && ddTeamList[0] == "0")) {
            ddTeamList.forEach(team => {
                strClauseTeam += this.teamObj.find(x => x.id.toString() == team).text + "<br />&nbsp;&nbsp;&nbsp;OR ";
            });
            strClauseTeam = "<br />&nbsp;&nbsp;&nbsp;(" + strClauseTeam.substring(0, strClauseTeam.length - 27) + ")";
            strClauseTeam = "<br /> AND Team includes " + strClauseTeam;
            this.sbClauseUser += strClauseTeam;
        }
        let strClauseOffice: string = "";
        const ddOfficeList = this.userDDSearchReqObj?.ddOffice;

        if (ddOfficeList && ddOfficeList.length > 0 && !(ddOfficeList.length == 1 && ddOfficeList[0] == "0")) {
            ddOfficeList.forEach(office => {
                strClauseOffice += this.officeObj.find(x => x.id.toString() == office).text + "<br />&nbsp;&nbsp;&nbsp;OR ";
            });
            strClauseOffice = "<br />&nbsp;&nbsp;&nbsp;(" + strClauseOffice.substring(0, strClauseOffice.length - 27) + ")";
            strClauseOffice = "<br /> AND Office includes " + strClauseOffice;
            this.sbClauseUser += strClauseOffice;
        }
    }

    async calculateRecordCount() {
        this.whereClause = '';
        this.setUserDDSearchReq();
        this.setPowerSearchRequest();
        this.showSpinner = true;
        await this._searchContactService.calculateRecordCount(this.encryptedUser, this.powerSearchRequest, this.user?.cLPCompanyID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var simpleResponse = UtilityService.clone(result);
                    if (!simpleResponse.messageBool) {
                        console.log('calculateRecord response error: ', simpleResponse.messageString2);
                        console.log('(whereClause)', simpleResponse.messageString);
                    }
                    this.searchContactCount = simpleResponse.messageInt + " records found";
                    this.whereClause = simpleResponse.messageString;
                    await this.setUserDDDisplay();
                    this.clauseUser = this.sbClauseUser;

                    //this.setUserDDDisplay();
                    //this.clauseUser = simpleResponse.messageString3;
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    setPowerSearchRequest() {
        this.powerSearchRequest = <PowerSearchRequest>{}
        this.powerSearchRequest.userDDSearchReq = this.userDDSearchReqObj;
        this.powerSearchRequest.searchClauseList = this.searchClauseList;
        this.powerSearchRequest.emailType = this.emailType;
        this.powerSearchRequest.havingScore = this.havingScore;
        this.powerSearchRequest.isEmailRequired = this.isEmailRequired;
        this.powerSearchRequest.isUseExtendedSearch = this.isUseExtendedSearch;
        this.powerSearchRequest.secClause = this.secClause;

    }

    setupSearchSummary() {
        if (!isNullOrUndefined(this.addToSearchReq.ddField) && this.addToSearchReq.ddField != '') {
            const ddFieldText: string = this.ddField.find(x => x.value == this.addToSearchReq.ddField).text;
            let strAndOr: string = '', strSQLClause = '', strClause = '';
            if (this.searchClauseList.length > 0)
                strAndOr = ' ' + this.addToSearchReq.ddAndOr + ' ';
            if (this.addToSearchReq.isEditText) {
                let strOp: string = '', strStartPercent = '', strEndPercent = '', ddOpSearchText = '';
                switch (this.addToSearchReq.ddOpSearchText) {
                    case '=':
                        strOp = '=';
                        ddOpSearchText = 'equals';
                        break;
                    case '<>':
                        ddOpSearchText = 'not equals';
                        strOp = '<>';
                        break;
                    case '>=':
                        strOp = '>=';
                        break;
                    case '<=': strOp = '<='; break;
                    case 'contains':
                        ddOpSearchText = 'contains';
                        strOp = 'like';
                        strStartPercent = '%';
                        strEndPercent = '%';
                        break;
                    case 'does not contain':
                        strOp = 'not like';
                        ddOpSearchText = 'does not contain';
                        strStartPercent = '%';
                        strEndPercent = '%'; break;
                    case 'starts':
                        strOp = 'like';
                        ddOpSearchText = 'starts with';
                        strEndPercent = '%';
                        break;
                    case 'ends':
                        strOp = 'like';
                        ddOpSearchText = 'ends with';
                        strStartPercent = '%';
                        break;
                    default:
                        break;
                }

                strSQLClause = strAndOr + "(" + this.addToSearchReq.ddField + " " + strOp + "'" + strStartPercent + this.addToSearchReq.txtSearch.replace(/ '\s*/g, '').replace(/"/g, '') + strEndPercent + "'" + ") ";
                strClause = `${strAndOr} ${ddFieldText} ${ddOpSearchText} '${this.addToSearchReq.txtSearch}'`;

            }
            else if (this.addToSearchReq.isddValue) {
                let strIn: string = '', strCL: string = '', sbCl = '';
                switch (this.addToSearchReq.ddField) {
                    case 'ISNULL(se.InfoSubStatus, 1)':
                    case 'ISNULL(se.PromoSubStatus, 1)':
                        this.addToSearchReq.ddValue.forEach(item => {
                            strIn += (item.toString() == '0') ? '1,' : '2,3,';
                            sbCl += '<li>' + this.ddValueList.find(x => x.id == Number(item)).text + '</li>';
                        });
                        break;
                    case 'Contact.isOptOutTxtMsg':
                        this.addToSearchReq.ddValue.forEach(item => {
                            strIn += (item.toString() == '1') ? '1,2,' : item + ',';
                            sbCl += '<li>' + this.ddValueList.find(x => x.id == Number(item)).text + '</li>';
                        });
                        break;

                    default:
                        this.addToSearchReq.ddValue.forEach(item => {
                            strIn += item + ',';
                            sbCl += '<li>' + this.ddValueList.find(x => x.id == Number(item)).text + '</li>';
                        });
                        break;
                }
                let ddOpClassText: string = '';
                if (strIn != '') {
                    strIn = '(' + strIn.substring(0, strIn.length - 1) + ')';
                    switch (this.addToSearchReq.ddOpClass) {
                        case '=': strIn = ' in ' + strIn;
                            ddOpClassText = 'equals';
                            break;
                        case '<>': strIn = ' not in ' + strIn;
                            ddOpClassText = 'not equals';
                            break;
                        default:
                            break;
                    }
                    strCL = `<ul>${sbCl}</ul>`;

                } else
                    strCL = 'Nothing was selected';
                strSQLClause = strAndOr + "(" + this.addToSearchReq.ddField + " " + strIn + ") ";
                strClause = `${strAndOr} ${ddFieldText} ${ddOpClassText}${strCL}`;

            }
            else if (this.addToSearchReq.isEditCB) {

                strClause = this.addToSearchReq.cbValue ? ddFieldText + ' is checked' : ddFieldText + ' is unchecked';
                strSQLClause = this.addToSearchReq.cbValue ? strAndOr + '(' + this.addToSearchReq.ddField + '=1)' : strAndOr + '(' + this.addToSearchReq.ddField + '=0)';

            }
            else if (this.addToSearchReq.isEditDate) {
                let blnIsFrom: boolean = false;
                if (this.addToSearchReq.fromDate != '') {
                    strSQLClause = strAndOr + '(' + this.addToSearchReq.ddField + " >= '" + this._datePipe.transform(new Date(this.addToSearchReq.fromDate), 'M/d/yyyy') + "' ";
                    blnIsFrom = true;
                    strClause = ddFieldText + ' is on or after ' + this._datePipe.transform(new Date(this.addToSearchReq.fromDate), 'M/d/yyyy');
                }
                if (this.addToSearchReq.toDate != '') {
                    const selectedDate = new Date(this.addToSearchReq.toDate);
                    const dtToDate = new Date(selectedDate).setDate(selectedDate.getDate() + 1);
                    //nextDay.setDate(nextDay.getDate() + 1);
                    if (blnIsFrom) {
                        strSQLClause += ' AND ' + this.addToSearchReq.ddField + " < '" + this._datePipe.transform(dtToDate, 'M/d/yyyy') + "' ";
                        strClause += '<br />and is on or before ' + this._datePipe.transform(selectedDate, 'M/d/yyyy');
                    } else {
                        strSQLClause = strAndOr + '(' + this.addToSearchReq.ddField + " < '" + this._datePipe.transform(dtToDate, 'M/d/yyyy') + "' ";
                        strClause = ddFieldText + ' is on or before ' + this._datePipe.transform(selectedDate, 'M/d/yyyy');
                    }
                }
                if (strSQLClause != '') strSQLClause += ") ";
            }
            else if (this.addToSearchReq.isMetricDetails) {
                let strIn: string = '';
                if (this.addToSearchReq.ddMetricNames != '' && this.addToSearchReq.lbMetricsSelected.length > 0 && this.addToSearchReq.ddMetricValues != "any text") {
                    this.addToSearchReq.lbMetricsSelected.forEach(item => {
                        strIn += "'" + item + "',";
                    });
                    strIn = ' in (' + strIn.substring(0, strIn.length - 1) + ')';
                    strClause += `Metric Name = ${this.addToSearchReq.ddMetricNames} and Metric Values ${this.addToSearchReq.ddMetricValues} ${strIn}.`;
                    let metricQuery: string = "(select  c.ContactID from dbo.contact c with(nolock)  inner join dbo.SOMetric sm with(nolock) on  c.ContactID =  sm.ContactID  where MetricName = '" + this.addToSearchReq.ddMetricNames + "' and MetricValue  ";
                    switch (this.addToSearchReq.ddMetricValues) {
                        case "all":
                            strSQLClause += ` and Contact.ContactID in ${metricQuery}${strIn} group by c.ContactID having COUNT(*)=${this.addToSearchReq.lbMetricsSelected.length}) `;
                            break;
                        case "any":
                            strSQLClause += ` and Contact.ContactID in ${metricQuery}${strIn}) `;
                            break;
                        case "not":
                            strSQLClause += ` and Contact.ContactID NOT in ${metricQuery}${strIn}) `;
                            break;
                        default:
                            break;
                    }
                }
                else if (this.addToSearchReq.ddMetricValues == "any text" && !isNullOrEmptyString(this.addToSearchReq.txtMetricTextSearch)) {
                    let metricTextQuery: string = "(select  c.ContactID from dbo.contact c with(nolock)  inner join dbo.SOMetric sm with(nolock) on  c.ContactID =  sm.ContactID  where MetricName = '" + this.addToSearchReq.ddMetricNames + "' and MetricValue like  '%" + this.addToSearchReq.txtMetricTextSearch + "%'";
                    strClause += `Metric Name = ${this.addToSearchReq.ddMetricNames} and Metric Values like ${this.addToSearchReq.txtMetricTextSearch} .`;
                    strSQLClause += ` and Contact.ContactID in ${metricTextQuery}) `;
                }
            }
            if (this.addToSearchReq.isBuzzScore) {
                this.havingScore = '';
                this.havingScoreDisplay = '';
                if (this.addToSearchReq.buzzStart != '' || this.addToSearchReq.buzzEnd != '') {
                    if (this.addToSearchReq.buzzStart == '0' && this.addToSearchReq.buzzEnd == '0') {
                        this.havingScore = " having sum(isNull(s.Score,0))=0 ";
                        this.havingScoreDisplay = "<br />AND Buzz Score is null or 0";
                    } else {
                        if (this.addToSearchReq.buzzStart != '' && this.addToSearchReq.buzzEnd != '') {
                            this.havingScore = ` having sum(isNull(s.Score,0))>=${this.addToSearchReq.buzzStart} and sum(isNull(s.Score,0))<=${this.addToSearchReq.buzzEnd} `;
                            this.havingScoreDisplay = `<br />AND Buzz Score is between  ${this.addToSearchReq.buzzStart} and ${this.addToSearchReq.buzzEnd} `;
                        } else if (this.addToSearchReq.buzzStart != '') {
                            this.havingScore = ` having sum(isNull(s.Score,0))>=${this.addToSearchReq.buzzStart} `;
                            this.havingScoreDisplay = `<br />AND Buzz Score Is >=  ${this.addToSearchReq.buzzStart} `;
                        } else if (this.addToSearchReq.buzzEnd != '') {
                            this.havingScore = ` having sum(isNull(s.Score,0))<=${this.addToSearchReq.buzzEnd} `;
                            this.havingScoreDisplay = `<br />AND Buzz Score Is =<  ${this.addToSearchReq.buzzEnd} `;
                        }
                    }
                }
            }
            if (this.addToSearchReq.isTags) {
                let strIn: string = '', sbTemp: string = ''

                this.addToSearchReq.lbTags.forEach(item => {
                    strIn += item + ',';
                    sbTemp += "'" + this.tagsObj.find(k => k.id.toString() == item).text + "',";
                });
                strIn = ' in (' + strIn.substring(0, strIn.length - 1) + ')';
                switch (this.addToSearchReq.ddOpTags) {
                    case 'all':
                        strSQLClause += strAndOr + `  (Contact.ContactID in (select OwnerID from TagItem WITH (NOLOCK) Where OwnerType=2 and TagID${strIn} group by OwnerID having COUNT(*)=${this.addToSearchReq.lbTags.length}))`;
                        strClause += strAndOr + `  are Tagged with all of (${sbTemp.substring(0, sbTemp.length - 1)})`;
                        break;
                    case 'any':
                        strSQLClause += strAndOr + `  (Contact.ContactID in (select OwnerID from TagItem WITH (NOLOCK) Where OwnerType=2 and TagID${strIn}))  `;
                        strClause += strAndOr + `  are Tagged with any of (${sbTemp.substring(0, sbTemp.length - 1)}) `
                        break;

                    case 'not':
                        strSQLClause += strAndOr + `   (Contact.ContactID NOT in (select OwnerID from TagItem WITH (NOLOCK) Where OwnerType=2 and TagID${strIn}))  `;
                        strClause += strAndOr + `   are not Tagged with any of (${sbTemp.substring(0, sbTemp.length - 1)}) `;
                        break;
                    default:
                }
            }

            if (!isNullOrUndefined(strClause) && strClause != '') {
                const newsearchClause = <SearchClause>{ sQLClause: strSQLClause, clauseText: strClause };
                this.searchClauseList.push(newsearchClause);
            }
        }
        else
            this.notifyService.showWarning('Please select a search field.', '');
        this.calculateRecordCount();
    }

    onMetricNamesChange(value: any) {
        this.isShowMetricValues = this.searchQueriesForm.controls['ddMetricNames'].value == '' ? false : true;
        if (this.searchQueriesForm.controls['ddMetricNames'].value != "") {
            this.showSpinner = true;
            this.engageMetricService.LoadMetricValuesbyNameCompanyID(this.encryptedUser, this.user?.cLPCompanyID, value)
                .then(async (result: SimpleResponse) => {
                    if (result) {
                        const response = UtilityService.clone(result);
                        this.listMetricValue = response.messageArray;
                        this.lblMetricName = this.searchQueriesForm.controls['ddMetricNames'].value;
                        if (this.listMetricValue.length > 0) {
                            this.isShowMetricValues = true;
                        }
                        else
                            this.isShowMetricValues = false;
                    }
                    this.showSpinner = false;
                })
                .catch((err: HttpErrorResponse) => {
                    console.log(err);
                    this._utilityService.handleErrorResponse(err);
                    this.showSpinner = false;
                });
        }
        else {
            this.searchQueriesForm.get("lbMetricsSelected").setValue("");
        }
    }
    onMetricValuesChange(value: any) {
        this.isMetricTextSearch = this.searchQueriesForm.controls['ddMetricValues'].value == 'any text' ? true : false;
    }


}
